const STEPS = [
  { key: "details", label: "Details" },
  { key: "photo", label: "Photo & ID" },
  { key: "briefing", label: "Briefing" },
  { key: "badge", label: "Badge" },
];

export function StepProgress({ current }) {
  const idx = STEPS.findIndex((s) => s.key === current);
  return (
    <div className="flex items-center justify-center gap-2 mb-8" data-testid="checkin-step-progress">
      {STEPS.map((s, i) => (
        <div key={s.key} className="flex items-center gap-2">
          <div
            data-testid={`step-indicator-${s.key}`}
            className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wide transition-colors ${
              i === idx ? "bg-brand-cyan text-brand-navy" : i < idx ? "bg-brand-navy text-white" : "bg-slate-200 text-slate-400"
            }`}
          >
            <span>{i + 1}</span>
            <span className="hidden sm:inline">{s.label}</span>
          </div>
          {i < STEPS.length - 1 && <div className={`w-6 h-px ${i < idx ? "bg-brand-navy" : "bg-slate-200"}`} />}
        </div>
      ))}
    </div>
  );
}
